import PaginationRequest from '@/common/pagination/entities/pagination-request'

export default class QuestionFilter {
  public search = ''
  public competenceId = ''
  public paging = new PaginationRequest()
}
